import axios from './axios'
import { Response } from '@/store/api/type'
import { AxiosRequestConfig, Method } from 'axios'

export const POST_METHOD = 'post'
export const GET_METHOD = 'get'
export const PUT_METHOD = 'put'
export const PATCH_METHOD = 'patch'
export const DELETE_METHOD = 'delete'

export const axiosHelper = (method: Method, url: string, data: any) => {
  return new Promise((resolve, reject) => {
    const option: AxiosRequestConfig = {
      method: method,
      url: url,
      data: data,
      timeout: 30000
    }

    axios(option)
      .then((resp: any) => {
        const response = resp.data as Response
        response.http_status = resp.status
        if (response.code <= 400) {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch((err: any) => {
        let data = err?.response?.data as Response
        if (typeof data == 'string') {
          data = {
            data: {},
            status: false,
            code: 0,
            code_text: '',
            error_message: 'เกิดข้อผิดพลาด',
            http_status: err?.response?.status
          }
        }
        reject(data)
      })
  })
}
